<header class="form-section-header" [ngStyle]="headerStyle">
    <h2
        [ngClass]="{
            'form-header-text-dark': !(themeService.isDarkModeEnabled$ | async),
            'form-header-text-light': themeService.isDarkModeEnabled$ | async
        }"
        [ngStyle]="titleStyle"
        class="form-header-text"
    >
        {{ title }}
    </h2>
    <ng-content></ng-content>
</header>
